import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { brandsData } from "../../data/brands-data";
import { useTranslation } from "react-i18next";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { AnimatePresence, motion } from "framer-motion";
import {
    containerVariants,
    itemVariants,
    photoVariants,
    photoVariants2,
} from "../../variants/variants";

import { Navigation, Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import LinkComponent from "../LinkComponent";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Banner from "../Banner";

const BrandsDetail = () => {
    const { t } = useTranslation();
    const { id1, id2 } = useParams();
    const category = brandsData.find((category) => category.link === id1);
    const product = category.products.find((product) => product.link === id2);

    // State to track the active slide index
    const [activeIndex, setActiveIndex] = useState(0);


    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);



    const bannerData = {
        // title: "ARGE",
        img: `/images/brands/${id1}/0.jpg`,
        logo:`/images/brands/${id1}/0.svg`
      };



    return (
        <div className="grid grid-cols-10">

        



            <div className="col-start-2 col-span-8 mb-28">


            <Banner bannerData={bannerData}/>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    exit="exit"
                    variants={containerVariants}
                    className=" w-full "
                >
                    
                </motion.div>

                <motion.div className="w-full text-25 font-light flex justify-center space-x-5 flex-wrap mt-7 mb-14">
                    {category.products.map((item, index) => (
                        <Link
                            to={`/markalar/${category.link}/${item.link}`}
                            key={index}
                            className="flex flex-col group"
                        >
                            <motion.div
                                animate={{ translateY: 0, opacity: 1 }}
                                initial={{ translateY: -10, opacity: 0 }}
                                transition={{
                                    duration: 1,
                                    ease: "easeInOut",
                                    delay: index * 0.2,
                                }}
                            >
                                {item.title}
                            </motion.div>
                            <motion.div
                                animate={{ translateY: 0, opacity: 1 }}
                                initial={{ translateY: -10, opacity: 0 }}
                                transition={{
                                    duration: 1,
                                    ease: "easeInOut",
                                    delay: index * 0.2,
                                }}
                            >
                                <div
                                    className={`h-px w-[0%] bg-black ${item.link === id2 && "w-[100%]"
                                        } group-hover:!w-[100%]  transition-all`}
                                ></div>
                            </motion.div>
                        </Link>
                    ))}
                </motion.div>

                <div className="space-y-10">
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        exit="exit"
                        variants={containerVariants}
                        className="grid grid-cols-1 md:grid-cols-2 gap-10"
                    >
                        <motion.div className="h-full overflow-hidden">
                            <Swiper
                                modules={[Pagination, Autoplay]}
                                pagination={{ clickable: true }}
                                autoplay={{ delay: 2000 }}
                                loop={true}
                                onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                                className="h-full overflow-hidden"
                            >
                                {product.images.map((image, index) => (
                                    <SwiperSlide
                                        className="h-full w-full overflow-hidden"
                                        key={index}
                                    >
                                        <motion.img
                                            initial="initial"
                                            whileInView="whileInView"
                                            exit="exit"
                                            variants={photoVariants}
                                            src={`/images/brands/${id1}/${id2}/${image}.jpg`}
                                            className="w-full h-full object-cover"
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </motion.div>

                        <div className="md:aspect-square flex flex-col justify-between">
                            <div className="flex flex-col mb-10">
                                <motion.h2
                                    variants={itemVariants}
                                    className="text-65 mb-5 text-customYellow"
                                >
                                    {product.title}
                                </motion.h2>
                                <motion.p
                                    variants={itemVariants}
                                    className="font-light text-customGray"
                                >
                                    {product.text}
                                </motion.p>
                            </div>
                            <div className="text-customGray">
                                <motion.h6 variants={itemVariants}>{t("products.productContent")}</motion.h6>
                                {product.detail.map((item, index) => (
                                    <motion.h6 variants={itemVariants} key={index}>
                                        {item}
                                    </motion.h6>
                                ))}
                            </div>
                        </div>
                    </motion.div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            exit="exit"
                            variants={containerVariants}
                            className="col-span-1 md:col-span-2 grid grid-cols-2 md:grid-cols-3 gap-2"
                        >
                            {product.images.map((item, index) => (
                                <div className="overflow-hidden">
                                    <motion.div
                                        animate={
                                            index === activeIndex ? { scale: 1.05 } : { scale: 1 }
                                        }
                                        transition={{ duration: 1 }}
                                        className="overflow-hidden"
                                        onClick={() => {
                                            setLightboxOpen(true);
                                            setLightboxIndex(index);
                                        }}
                                    >
                                        <div className="group cursor-pointer">
                                            <motion.div
                                                key={index}
                                                className="aspect-square  overflow-hidden relative"
                                            >
                                                <AnimatePresence>
                                                    {index === activeIndex && (
                                                        <motion.div
                                                            animate={{ scale: 1 }}
                                                            initial={{ scale: 0 }}
                                                            transition={{ duration: 1 }}
                                                            exit={{ scale: 0 }}
                                                            className="absolute z-50 top-4 left-4"
                                                        >
                                                            <div className=" h-5 w-5  bg-black rounded-full  group-hover:scale-125 transition-all duration-300 group-hover:opacity-50"></div>
                                                        </motion.div>
                                                    )}
                                                </AnimatePresence>

                                                <div className="h-full w-full group-hover:scale-125 transition-all duration-300 ease-in-out">
                                                    <motion.img
                                                        custom={index}
                                                        initial="initial"
                                                        whileInView="whileInView"
                                                        exit="exit"
                                                        variants={photoVariants2}
                                                        src={`/images/brands/${id1}/${id2}/${item}.jpg`}
                                                        className="w-full h-full object-cover"
                                                    />
                                                </div>

                                                <div className="absolute bottom-2 right-2 opacity-0 group-hover:opacity-80 duration-300 ">
                                                    <img
                                                        src="/images/icons/magnifying-glass.svg"
                                                        className=" h-7 w-7"
                                                    />
                                                </div>
                                            </motion.div>
                                        </div>
                                    </motion.div>
                                </div>
                            ))}
                        </motion.div>
                    </div>
                </div>



                {lightboxOpen && (
                    <Lightbox
                        open={lightboxOpen}
                        close={() => setLightboxOpen(false)}
                        slides={product.images.map((img) => ({
                            src: `/images/brands/${id1}/${id2}/${img}.jpg`,
                        }))}
                        index={lightboxIndex}
                        onIndexChange={setLightboxIndex}
                    />
                )}















                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    exit="exit"
                    variants={containerVariants}
                    className=" flex flex-col mt-20 space-y-2"
                >
                    <motion.h6 className="mb-2" variants={itemVariants}>
                        DİĞER MARKALAR
                    </motion.h6>

                    {brandsData.map((item, index) => {
                        return (
                            <Link
                                to={`/markalar/${item.link}/${item.products[0].link}`}
                                className="hover:translate-x-2 ease-in-out duration-300"
                            >
                                <motion.h6
                                    variants={itemVariants}
                                    key={index}
                                    className={`flex flex-col text-14 font-light ${item.link === id1 && "font-normal"
                                        }`}
                                >
                                    {item.title.map((item2, index) => {
                                        return (
                                            <>
                                                {item2}
                                                &nbsp;
                                            </>
                                        );
                                    })}
                                </motion.h6>
                            </Link>
                        );
                    })}
                </motion.div>
















            </div>
        </div>
    );
};

export default BrandsDetail;
